// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_14vqd","productBadge":"mAarB","badge":"_2cC7R","defaultImage":"_1DVrV"};